const ABOUT_IMG = '/img/sobre.png';

const tags = ['Atendimento humanizado', 'Baseado em evidências', 'Foco em longevidade'];

export default function AboutSection() {
  return (
    <section id="sobre" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -top-4 -left-4 w-full h-full border-2 border-[#6B705C]/30 rounded-2xl"></div>
              <img
                src={ABOUT_IMG}
                alt="Atendimento médico humanizado"
                className="relative w-full h-[350px] object-cover object-top rounded-2xl shadow-xl"
              />
              <div className="absolute -bottom-4 -right-4 bg-white rounded-xl p-4 shadow-lg border border-[#DDE0D7]">
                <div className="flex items-center gap-3">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#4F5D4A] to-[#6B705C] rounded-full flex items-center justify-center">
                    <i className="ri-heart-pulse-line text-white text-xl"></i>
                  </div>
                  <div>
                    <p className="text-2xl font-bold text-[#6B705C]">+1000</p>
                    <p className="text-xs text-[#3A3A3A]/60">Pacientes atendidos</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Text */}
          <div className="order-1 lg:order-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-[2px] bg-gradient-to-r from-[#4F5D4A] to-[#6B705C]"></div>
              <span className="text-sm font-semibold text-[#6B705C] uppercase tracking-wider">Sobre a Médica</span>
            </div>
            <h2 className="text-3xl lg:text-4xl font-bold text-[#3A3A3A] mb-8 leading-tight">
              Cuidado, prevenção e{' '}
              <span className="text-[#6B705C]">acompanhamento contínuo</span>
            </h2>
            <div className="space-y-5 text-[#3A3A3A]/70 leading-relaxed text-base">
              <p>
                Sou a <strong className="text-[#3A3A3A]">Dra. Mariangela Escobar Gonçalves</strong>, médica com foco
                no cuidado integral do adulto e, principalmente, do idoso. Iniciei minha jornada na saúde ainda
                jovem, passando pela Biomedicina e, posteriormente, pela Medicina.
              </p>
              <p>
                Acredito que cuidar da saúde vai muito além de tratar sintomas — envolve orientação,
                acompanhamento e promoção de um{' '}
                <strong className="text-[#3A3A3A]">estilo de vida mais saudável e longevo</strong>.
              </p>
            </div>
            <div className="mt-8 flex flex-wrap gap-4">
              {tags.map((t) => (
                <div key={t} className="flex items-center gap-2 bg-[#F5F5F0] px-4 py-2 rounded-full">
                  <i className="ri-check-line text-[#6B705C]"></i>
                  <span className="text-sm font-medium text-[#3A3A3A]">{t}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}